<div *ngIf="data">
  <div mat-dialog-content>
    <h4>{{data.header}}</h4>
    <p>{{data.message}}</p>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button (click)="onNoClick()" cdkFocusInitial>{{'DIALOG.NO' | translate}}</button>
    <button mat-raised-button color="warn" (click)="onYesClick()" [mat-dialog-close]="true">{{'DIALOG.YES' | translate}}</button>
  </div>
</div>